import Vue from 'vue'

const error = (text, params = {}) => {
    notify(text, 'error', params)
}

const warning = (text, params = {}) => {
    notify(text, 'warn', params)
}

const info = (text, params = {}) => {
    notify(text, 'info', params)
}

const success = (text, params = {}) => {
    notify(text, 'success', params)
}

const custom = (text, params = {}) => {
    notify(text, 'custom', params)
}

export default {
    error,
    warning,
    info,
    success,
    custom
}

const notify = (text, type, params) => {
    let notification = buildNotifyObject(text, type, params)

    Vue.notify(notification)
}

const buildNotifyObject = (text, type, params) => {
    let data = {}
    let icons = {
        error: 'fa fa-times',
        success: 'fa fa-check',
        warn: 'fa fa-exclamation-triangle',
        info: 'fa fa-info-circle',
        custom: 'fa fa-bell'
    }
    let notification = {
        title: null
    }

    data['icon'] = params.icon || icons[type]
    data['link'] = params.link

    delete params.icon
    delete params.link

    return {
        ...notification,
        ...params,
        type,
        text,
        data
    }
}



// WEBPACK FOOTER //
// ./src/utils/helpers/notify.js